<template>
	<div
		v-if="items.length > 0"
		:class="['panel', 'review',
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.appearance? block.appearance : ''
		]"
	>
		<div class="container">
			<div
				v-if="isHeaderVisible"
				:class="[
					'panel_header',
					isBrand? 'sk' : '',
				]"
			>
				<div class="row align-items-end">
					<div class="col-12">
						<h2>{{ block.block_title }}</h2>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-12 col-lg-4">
					<div class="subtitle text-center text-sm-left">
						{{ block.description }}
					</div>

					<div v-if="person" class="row mb-4 mb-lg-0">
						<div class="col-8 offset-2 offset-sm-0 col-sm-4 col-md-4 col-lg-4 mb-3 mb-sm-0">
							<img :src="person.square_photo" class="rounded-circle">
						</div>
						<div class="col-12 col-sm-8 col-md-8 col-lg-8 align-self-center text-center text-sm-left">
							<div class="title">
								{{ person.title }}
							</div>
							<p class="description">
								{{ person.job_title }}
							</p>

							<div  v-if="person.primary_logos">
								<div v-for="(item, index) in person.primary_logos" :key="index">
									<img :src="item.src" width="100">
								</div>
							</div>

						</div>

						<!-- <div class="w-100 text-center mt-4"> -->
						<!-- <button class="btn btn-primary" @click="review"> -->
						<!-- Оставьте свой отзыв -->
						<!-- </button> -->
						<!-- </div> -->
					</div>
				</div>

				<div class="col-12 col-lg-8">
					<div class="page-content">
						<div class="block-bio">
							<div class="row">
								<div class="col-12 col-lg-3">
									<div class="subtitle" />
								</div>
								<div class="col-12 col-lg-9">
									<div class="content">
										<blockquote v-if="current" v-html="current.review" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row justify-content-end">
				<div class="col-12 col-lg-6">
					<div class="swiper-navigation border-top mt-3 pt-4">
						<!--
						можно набрасывать классы, когда нет следующего или предыдущего элемента
						disabled - что бы сделать кнопку не активной, или
						d-none - что бы скрыть элемент кнопки вообще
						-->
						<button
							class="btn btn-secondary icon-arrow_prev"
							:class="selected === 0 ? 'd-none' : ''"
							@click="previous"
						/>
						<button
							class="btn btn-secondary icon-arrow_next"
							:class="selected === (items.length - 1) ? 'd-none' : ''"
							@click="next"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import panel from '~/mixins/panel';

export default {
	name: 'PanelReview',
	mixins: [panel],
	data() {
		return {
			selected: 0,
		};
	},
	computed: {
		items() {
			const { media } = this.block || {};

			if (Array.isArray(media)) return media;

			return [];
		},
		current() {
			return this.items.length > 0 ? this.items[this.selected] : null;
		},
		person() {
			return this.current && Array.isArray(this.current.people) ? this.current.people[0] : null;
		},
	},
	methods: {
		async review() {
			const text = 'test';
			await this.$api.review({
				block_id: this.block.id,
				text,
			});
		},
		previous() {
			if (this.selected > 0) {
				this.selected -= 1;
				return;
			}

			if (this.items.length > 0) {
				this.selected = this.items.length - 1;
				return;
			}

			this.selected = 0;
		},
		next() {
			if (this.items.length === 0 || this.selected === (this.items.length - 1)) {
				this.selected = 0;
				return;
			}

			this.selected += 1;
		},
	},
};
</script>

<style lang="scss" scoped>
	// Это потом удалить, если будет использоваться компонент HtmlRaw для цитаты
	@import "~/assets/styles/components/dev/html-raw-bio";
</style>
